import { Model } from '@ofqual/portal-core/core/types';
export type LcmModel = {
 id: string;
 createdDate: string;
 modifiedDate: string;
 createdUpn: string;
 createdByDisplayName: string;
 modifiedbyUpn: string;
 caseTitle: string;
 referenceNumber: string;
 assignedCreatedDate: string;
 status: LcmStatus;
 summary: string;
 directorate: number[];
 team: string;
 requestedBy: number | null;
 matterType: number | null;
 category: number | null;
 subCategory: number | null;
 dueDate: string;
 lineManagerUpn: string;
 lineManagerDisplayName: string;
 counselTelephone: string;
 counselEmail: string;
 counselTags: string;
 counselSummaryAdvice: string;
 counselReceivedFrom: string;
 counselKeywords: string;
 assignedTo: string[];
 policyCategory: number | null;
 policySubCategory: number | null;
 taggingSummary: string;
 taggingReceivedFrom: string;
 keywordId: number[];
 sensitive: boolean;

 awardingOrg: {
  id: string;
  lcmId: string;
  orgId: string;
  contactName: string;
  contactEmail: string;
 }[];
};

export enum LcmStatus {
 'New' = 0,
 'Open' = 1,
 'Cancelled' = 2,
 'Closed' = 3,
 'Pending Approval' = 4,
}

export const fromApiModel = (model: Model): LcmModel => {
 return {
  ...model,
 } as LcmModel;
};

export const toApiModel = (item: LcmModel): Model => {
 return {
  ...item,
 } as Model;
};
